"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileSection = exports.SubHeading = exports.PhoneNumber = exports.InfoLine = exports.Icon = exports.HoursContainer = exports.Heading = exports.DealerTile = exports.DealerNameContainer = exports.DealerName = exports.DealerInfoContainer = exports.DealerFlexContainer = exports.DealerDistance = exports.AddressContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const DealerTile = exports.DealerTile = _styledComponents.default.div`
  background: #000;
  color: #FFF;
  padding: 40px 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  min-height: 690px;
`;
const TileSection = exports.TileSection = _styledComponents.default.div``;
const Icon = exports.Icon = _styledComponents.default.div`
  margin-bottom: 4px;
`;
const Heading = exports.Heading = _styledComponents.default.div`
  margin-bottom: 8px;
`;
const SubHeading = exports.SubHeading = _styledComponents.default.div``;
const DealerNameContainer = exports.DealerNameContainer = _styledComponents.default.div``;
const DealerName = exports.DealerName = _styledComponents.default.div`
  margin-bottom: 8px;
`;
const DealerDistance = exports.DealerDistance = _styledComponents.default.span`
  display: inline-block;
`;
const PhoneNumber = exports.PhoneNumber = _styledComponents.default.div``;
const DealerInfoContainer = exports.DealerInfoContainer = _styledComponents.default.div`
  margin-bottom: 24px;
`;
const DealerFlexContainer = exports.DealerFlexContainer = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
const AddressContainer = exports.AddressContainer = _styledComponents.default.div`

`;
const HoursContainer = exports.HoursContainer = _styledComponents.default.div`
`;
const InfoLine = exports.InfoLine = _styledComponents.default.div`
  margin-bottom: 4px;
`;